<template>
  <div>
    <div>
      <div class="page-body">
        <bar :titleBar="titleBar"
             v-if="!fromOrderPage" @change="changeType">
        </bar>
      </div>
        <coupon-selection  :myAllCoupons="myCoupons" :comeFrom="fromOrderPage"></coupon-selection>
    </div>
  </div>

</template>

<script>
import {mapState} from 'vuex'
import Bar from '../../../views_fc/multiplex/Bar'
import CouponSelection from '../../../views_v_2.6/Order/CouponSelection'
// import wx from 'wx'
// import EMKT from '../../../emkt'
export default {
  components: {CouponSelection, Bar},
  props: {
    // 该变量区分是否是订单页面，订单页面需要使用优惠券，因此为true，
    // 默认为false，只作为展示，没有使用功能
  },
  created () {
    this.fetchData()
    this.overdue()
  },
  data () {
    return {
      myCoupons: [],
      overdueCoupons: [],
      serviceCoupons: [],
      toolsCoupons: [],
      fromOrderPage: this.$route.query.fromOrderPage,
      titleBar: [
        {
          label: '科研工具',
          value: '',
          length: 0
        },
        {
          label: '科研服务',
          value: '3',
          length: 0
        },
        {
          label: '已过期',
          value: '-',
          length: 0
        }
      ],
      chooseLength: 0
    }
  },
  computed: {
    ...mapState([
      'sessionInfo'
    ]),
    'count': function () {
      return this.sessionInfo.expressAddress.length
    }
  },
  methods: {
    fetchData () {
      this.$weui.loading('正在获取优惠券')
      let customerNo = this.sessionInfo.customerInfo.customerNo
      let coupons = []
      this.gcapi('getMyCoupons', customerNo).then((res) => {
        this.$weui.loading().hide()
        res.body.result.forEach(item => {
          item.open = true
          item.desc = item.description.split('|')
          item.available = true
          if (item.applied === 0) {
            coupons.push(item)
          }
        })
        coupons.sort((a, b) => b.enableFlag - a.enableFlag)
        coupons.forEach(item => {
          if (item.promotionUseType === 3) {
            this.serviceCoupons.push(item)
          } else {
            this.toolsCoupons.push(item)
          }
        })
        this.titleBar[0].length = this.toolsCoupons.length
        this.titleBar[1].length = this.serviceCoupons.length
      })
      if (this.$route.params.isService === true || this.$route.params.isService === false) {
        this.myCoupons = coupons
      } else {
        this.myCoupons = this.toolsCoupons
      }
      console.log(this.myCoupons, 'muc')
    },
    overdue () {
      let customerNo = this.sessionInfo.customerInfo.customerNo
      this.gcapi('getMyOverdueCoupons', customerNo).then((res) => {
        res.body.result.forEach(item => {
          item.open = true
          item.desc = item.description.split('|')
          item.available = false
          console.log(item)
        })
        this.overdueCoupons = res.body.result
        this.titleBar[2].length = this.overdueCoupons.length
      })
    },
    changeType (type) {
      if (type === '-') {
        this.myCoupons = this.overdueCoupons
      } else {
        this.classify(type)
      }
    },
    classify (type) {
      console.log(type === '3')
      if (type === '3') {
        console.log(this.serviceCoupons)
        this.myCoupons = this.serviceCoupons
      } else {
        console.log(this.toolsCoupons)
        this.myCoupons = this.toolsCoupons
      }
    },
    // confirmCoupon () {
    //   this.$refs.coupons.confirmCoupon()
    // },
    // changeNumber () {
    //   this.chooseLength = this.$refs.coupons.chosenCoupons.length
    // },
    FormatterTime (date) {
      let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      let currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      let currenthours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      let currentMinutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      let currentSeconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      let newTime = date.getFullYear() + '-' + month + '-' + currentDate + ' ' + currenthours + ':' + currentMinutes + ':' + currentSeconds
      return newTime
    }
  },
  filters: {
    currencyStyle (val) {
      return ' ¥ ' + val
    }
  }
}

</script>

<style scoped src="../../../views_fc/styleSheet/universal.css">
.top {
  margin-top: -1rem;
  -webkit-line-clamp: 3;
  height: 3rem;
}

</style>
<style scoped>
.page-body {
  padding: 2.5%;
  background-color: white;
}
.header-subtitle {
  background-color: #fe654d;
  line-height: 25px;
  font-size: 12px;
  color: #fff;
  width: 100%;
  z-index: 10;
  padding-left: 5%;
}
.footer {
  position: fixed;
  bottom:0;
  left: 0;
  width: 100%;
  font-size: 14px;
  background-color: #fff;
}
.footer-content {
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 9px 10px;
}
.alert-text {
  color: #FE654D;
}
.pay-btn {
  width: 110px;
  height: 34px;
  border-radius: 17px;
  line-height: 34px;
  color: #fff;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// MyCoupons.vue?7c02c5e9